import { styles } from './template.scss';
import { styles as commonImStyles } from '../../common/common.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';

export const templateIntegrityMonitorAssignRulesForm = document.createElement('template');

templateIntegrityMonitorAssignRulesForm.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${commonImStyles}</style>
  <style>${styles}</style>
  <div class='wrapper'>

    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='form-wrapper'>
      <div class='form-section'>
        <gz-title fontWeight="500" fontSize='18' class='title mb-2' id='assign-rules-title'></gz-title>

        <gz-text fontWeight="400" fontSize="14" lineHeight="1.2" id="assign-rules-description"/></gz-text><br>

        <gz-enum-filter id="assign-rules-rule-sets-selector" labelWidth="240" disabled></gz-enum-filter>
      </div>
    </div>

    <div class='bottom-buttons'>
      <gz-button id='assignButton' disabled></gz-button>
      <div class='flex-auto'></div>
      <gz-button id='cancelButton' type='outline' color='secondary'></gz-button>
    </div>
  </div>
`;
